export default "__VITE_ASSET__DKHBXlTW__"